import media from '@/styles/media';
import React, {
  useCallback, useEffect, useMemo, useRef, useState,
} from 'react';
import styled, { keyframes } from 'styled-components';

const ModalContainer = styled.div<{clear?:boolean}>`
  display:none;
  flex-direction:column;
  align-items:center;
  justify-content:center;
  background-color:rgba(0,0,0,0.4);
 ${({ clear }) => (!clear && ' backdrop-filter: blur(5px)')};
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:99999;
  padding:0;
  cursor:default;
  transition: opacity .2s;
  &.show {
    display:flex;
    animation: ${keyframes`from{opacity:0;}`} .2s;
  }
  &.hiding {
    opacity: 0;
  }

  ${media.md`
    /* padding: 0 10px; */
    box-sizing: border-box;
  `}
`;

export const CloseModalButton = styled.img.attrs({
  src: '/assets/images/common/close.svg',
  alt: 'close',
})`
  position: absolute;
  top: 24px;
  right: 24px;
  width: 48px;
  height: 48px;
  cursor: pointer;

`;

interface Props {
  show: boolean;
  onClose?: () => void;
  closeOnClickOverlay?: boolean;
  offset?: {
    top?: number;
    right?: number;
    left?: number;
    bottom?: number;
  }
  onHide?: () => void;
  backgroundOpacity?: number;
  zIndex?: number;
  clear?: boolean;
}

const Modal : React.FC<Props> = ({
  show = false, onClose, closeOnClickOverlay = true, children, offset, onHide, backgroundOpacity = 0.3, zIndex = 99,
  clear,
}) => {
  const [hiding, setHiding] = useState(false);
  const modalRef = useRef<HTMLDivElement>(null);
  const [pcSizeHide, setPcSizeHide] = useState<boolean>(false);

  const closeModal = useCallback((e : React.MouseEvent) => {
    if (!closeOnClickOverlay) {
      return;
    }
    if (e.target !== e.currentTarget) {
      return;
    }

    setHiding(true);
    if (onHide) onHide();
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
      setHiding(false);
    }, 200);
  }, [closeOnClickOverlay, onClose, onHide]);

  useEffect(() => {
    Array.from(document.querySelectorAll('audio')).forEach((el) => el.pause());
  }, [show]);

  const injectStyle = useMemo(() => {
    const offsetValue = {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      ...offset,
    };
    const top = `${offsetValue.top}px`;
    const left = `${offsetValue.left}px`;
    const width = `calc(100% - ${offsetValue.right}px - ${left})`;
    const height = `calc(100% - ${offsetValue.bottom}px - ${top})`;
    const backgroundColor = `rgba(0,0,0,${backgroundOpacity})`;
    return {
      top,
      left,
      width,
      height,
      backgroundColor,
      zIndex,
    };
  }, [backgroundOpacity, offset, zIndex]);

  const loginPage = window.location.pathname.split('/')[3];
  useEffect(() => {
    if (loginPage) {
      if (window.innerWidth < 768) {
        if (modalRef.current) { modalRef.current.style.padding = '0'; }
      }
    }
  }, [loginPage]);

  return (
    <ModalContainer
      className={`${show ? 'show' : ''} ${hiding ? 'hiding' : ''}`}
      onClick={closeModal}
      ref={modalRef}
      style={injectStyle}
      clear={clear}
    >
      {children}
    </ModalContainer>
  );
};

export default Modal;
